import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import {
  CheckoutModel,
  ScriptModel,
} from '../../interfaces/trust-badge.interface';

@Injectable()
export class TrustBadgeService {
  private scripts: ScriptModel[] = [];

  public load(script: ScriptModel): Observable<ScriptModel> {
    return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
      const existingScript = this.scripts.find((s) => s.name === script.name);

      // Complete if already loaded
      if (existingScript && existingScript.loaded) {
        observer.next(existingScript);
        observer.complete();
      } else {
        // Add the script
        this.scripts = [...this.scripts, script];

        const existingContainer = document.getElementById(
          'trustedShopsCheckout'
        );

        if (!existingContainer) {
          const checkoutContainer = this.createCheckoutElement(
            'div',
            'trustedShopsCheckout'
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutOrderNr')
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutBuyerEmail')
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutOrderAmount')
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutOrderCurrency')
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutOrderPaymentType')
          );
          checkoutContainer.appendChild(
            this.createCheckoutElement('span', 'tsCheckoutOrderEstDeliveryDate')
          );
          checkoutContainer.style.display = 'none';
          document
            .getElementsByTagName('body')[0]
            .appendChild(checkoutContainer);
        }

        // Load the script
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = script.src;
        scriptElement.charset = 'utf-8';
        scriptElement.async = true;

        scriptElement.onload = () => {
          script.loaded = true;
          observer.next(script);
          observer.complete();
        };

        scriptElement.onerror = (error: any) => {
          observer.error("Couldn't load script " + script.src);
        };

        document.getElementsByTagName('body')[0].appendChild(scriptElement);
      }
    });
  }

  public invokeBadge(checkoutData: CheckoutModel): void {
    const container = document.getElementById('trustedShopsCheckout');

    if (!container) {
      console.error('container not found');
      return;
    }

    if (container) {
      Object.keys(checkoutData).forEach((key) => {
        container.querySelector(`#${key}`).innerHTML = checkoutData[key];
      });

      console.log(container);
    }
  }

  private createCheckoutElement(tag: string, id: string): any {
    const element = document.createElement(tag);
    element.id = id;

    return element;
  }
}
